<style scoped lang="scss">
@media screen and (max-width: 640px){
  .area li {
    margin-left: auto;
    margin-right: auto;
  }
}
.container10{
  margin-top: 80px;
}
.container10 h1{
  font-size: 70px;
  color: #014492;
}
.cons{
  display: none;
}
.container10 h2{
  font-size: 40px;
  color: #014492;
}
.container10 .a{
  width: 1200px;
  height: 6px;
  margin-top: 30px;
  margin-bottom: 40px;
  background: #ccc;
  position: relative;
}
.container10 .a span{
  width: 50px;
  height: 6px;
  position: absolute;
  left: 0;
  top: 0;
  background: #014492;
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/banner_17.png" class="img-fluid">-->
<!--      <div class="info">-->
<!--        <div class="container">-->
<!--          <h1>全长转录组测序iso-seq</h1>-->
<!--          <h2 class="mt10">Full-length transcriptome sequencing iso-seq（全面·经典）</h2>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="container container10">
      <h1>全长转录组测序iso-seq</h1>
      <h2 class="mt10">Full-length Transcriptome Sequencing iso-seq（全面·经典）</h2>
      <div class="a"><span></span></div>
    </div>
    <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;">
      <bread></bread>
    </div>
    <section class="container">
      <p class="desc">全长转录组测序（Iso-seq）是基于PacBio单分子实时测序技术，凭借超长读长的优势，无需打断RNA分子，直接对反转录的全长cDNA测序，即可得到从5’末端到3’PolyA尾的高质量全长转录本序列，从而对同源异构体（isoform）、可变剪接、融合基因、同源基因、超家族基因、等位基因表达等进行精确分析。</p>
      <div class="c-title">应用领域</div>
      <div class="con">
        <ul class="lists area">
          <li>
            <img src="@/assets/images/full_icon_1.png">
            <p>可变剪接</p>
          </li>
          <li>
            <img src="@/assets/images/full_icon_2.png">
            <p>融合基因</p>
          </li>
          <li>
            <img src="@/assets/images/prokaryotic_icon_1.png">
            <p>新转录本/新内含子</p>
          </li>
          <li>
            <img src="@/assets/images/full_icon_3.png">
            <p>全长转录组</p>
          </li>
          <li>
            <img src="@/assets/images/eukaryotic_icon_2.png">
            <p>异构体</p>
          </li>
          <li>
            <img src="@/assets/images/full_icon_4.png">
            <p>novel基因</p>
          </li>
        </ul>
      </div>
      <div class="cons" style="margin-top: 20px;">
        <ul class="lists area">
          <li>
            <img src="@/assets/images/full_icon_1.png">
            <p>可变剪接</p>
          </li>
          <li>
            <img src="@/assets/images/full_icon_2.png">
            <p>融合基因</p>
          </li>
          <li>
            <img src="@/assets/images/prokaryotic_icon_1.png">
            <p>新转录本/新内含子</p>
          </li>
          <li>
            <img src="@/assets/images/full_icon_3.png">
            <p>全长转录组</p>
          </li>
          <li>
            <img src="@/assets/images/eukaryotic_icon_2.png">
            <p>异构体</p>
          </li>
          <li>
            <img src="@/assets/images/full_icon_4.png">
            <p>novel基因</p>
          </li>
        </ul>
      </div>
      <div class="c-title">技术参数</div>
      <ul class="lists">
        <li>
          <img src="@/assets/images/prokaryotic_icon_4.png">
          <h4>测序平台及策略</h4>
          <p>PacBio</p>
        </li>
        <li>
          <img src="@/assets/images/prokaryotic_icon_5.png">
          <h4>项目周期</h4>
          <p>50个工作日</p>
        </li>
        <!-- <li>
          <img src="@/assets/images/prokaryotic_icon_6.png">
          <h4>测量数据量</h4>
          <p>30G</p>
        </li> -->
        <li>
          <img src="@/assets/images/prokaryotic_icon_7.png">
          <h4>数据质量</h4>
          <p>≥ 20万条 full-length reads</p>
        </li>
      </ul>
      <div class="c-title">技术路线</div>
      <div class="tc con"><img src="@/assets/images/full_1.png"> </div>
      <div class="tc cons" style="margin-top: 20px;"><img src="@/assets/images/full_1.png"> </div>
    </section>
    <qk-consult type="Virus"/>
  </div>
</template>
<script>
import bread from "@/components/bread"
export default {
  inject: ['reload'],
  components: {
    bread,
  },
  data () {
    return {

    }
  },
  created() {
    this.reload()
  },
  methods: {

  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/full_length.vue